export enum Permissions {
	ADMIN = 'ADMIN',
	MANAGE_STORAGE = 'MANAGE_STORAGE',
	MANAGE_MATERIALS = 'MANAGE_MATERIALS',
	MANAGE_METADATA = 'MANAGE_METADATA',
	MANAGE_NOTIFICATIONS = 'MANAGE_NOTIFICATIONS',
}
